// ---------------------------------------------------------------------------
// Feedback types — follows the same as-const pattern as notification.ts
// ---------------------------------------------------------------------------

export const FeedbackType = {
  BUG: "bug",
  FEEDBACK: "feedback",
  FEATURE_REQUEST: "feature_request",
} as const;

export type FeedbackType = (typeof FeedbackType)[keyof typeof FeedbackType];

export const FeedbackPriority = {
  LOW: "low",
  MEDIUM: "medium",
  HIGH: "high",
  CRITICAL: "critical",
} as const;

export type FeedbackPriority =
  (typeof FeedbackPriority)[keyof typeof FeedbackPriority];

export const FeedbackStatus = {
  RECEIVED: "received",
  INVESTIGATING: "investigating",
  IN_PROGRESS: "in_progress",
  RESOLVED: "resolved",
  CLOSED: "closed",
} as const;

export type FeedbackStatus =
  (typeof FeedbackStatus)[keyof typeof FeedbackStatus];

export interface FeedbackAttachment {
  id: string;
  filename: string;
  s3_key: string;
  mime_type: string;
  size: number;
  uploaded_at: string;
}

export interface FeedbackComment {
  id: string;
  author_name: string;
  author_source: "slack" | "app";
  text: string;
  created_at: string;
}

export interface FeedbackItem {
  id: string;
  user_id: string;
  type: FeedbackType;
  title: string;
  description: string;
  priority: FeedbackPriority;
  status: FeedbackStatus;
  attachments: FeedbackAttachment[];
  comments: FeedbackComment[];
  page_url?: string;
  browser_info?: string;
  slack_thread_ts?: string;
  createdAt: string;
  updatedAt: string;
}

export interface FeedbackListResponse {
  items: FeedbackItem[];
  total: number;
  page: number;
  limit: number;
}

export interface FeatureRating {
  id: string;
  user_id: string;
  feature_key: string;
  rating: number;
  comment?: string;
  createdAt: string;
  updatedAt: string;
}

export interface FeatureRatingsResponse {
  ratings: FeatureRating[];
}

export const RATABLE_FEATURES = [
  { key: "ai_chat", label: "AI Chatbot" },
  { key: "meeting_room", label: "Video Meetings" },
  { key: "candidate_pipeline", label: "Candidate Pipeline" },
  { key: "candidate_search", label: "Discover Talent" },
  { key: "project_management", label: "Projects" },
  { key: "client_management", label: "Clients" },
  { key: "talent_pools", label: "Talent Pools" },
  { key: "company_directory", label: "Company Directory" },
] as const;

export type RatableFeatureKey = (typeof RATABLE_FEATURES)[number]["key"];
